@if (
  {
    userdata: (userService.fullUserDetails.userData | async) || {},
    services: (userService.fullUserDetails.userServices | async) || {},
    baskets: (basketService.baskets | async) || [],
    selectedBasket: ((selectedBasket || {}).subject | async) || {
      basketItems: []
    },
    deletingBasket: basketService.deletingBasket.value,
    miUpdating: (basketService.miUpdating | async) || false
  };
  as data
) {
  @if (!basketService.basketUpdating) {
    <div class="basket_panel_header" aria-live="polite">
      <h2 class="basket_panel_heading">
        @if (!displayItinerary) {
          <i class="material-icons" aria-hidden="true">shopping_basket</i>
        }
        @if (displayItinerary) {
          <img
            class="luggage_icon"
            aria-hidden="true"
            src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/luggage_icon.svg"
            alt=""
          />
        }
        @if (!displayItinerary) {
          <span i18n="@@basketPanelCart">Baskets</span>
        }
        @if (displayItinerary) {
          <span i18n="@@basketPanelItineraries">Itineraries</span>
        }
      </h2>
      <dl class="basket-item-count">
        <dt i18n="@@basketItems">Items:</dt>
        <dd
          id="ripple_test"
          class="custom_ripple no-click"
          role="contentinfo"
          attr.aria-label="There are {{
            (data.selectedBasket || { basketItems: 0 }).basketItems.length
          }} Items in the cart"
        >
          {{ (data.selectedBasket || { basketItems: [] }).basketItems.length }}
        </dd>
      </dl>
      @if (!searchPage) {
        <div class="basket-item-reset">
          <button
            appButton="small"
            (click)="startAgain()"
            id="basket-button-start-again"
            i18n="@@basketPanelStartAgain"
            aria-label="Start Again"
          >
            Start Again
          </button>
        </div>
      }
    </div>
  }
  <div class="multi_baskets_container" id="basket_contents_container">
    <div class="multi_basket_add_row">
      <section (mouseleave)="tt6.close()">
        <button
          appButton="small"
          id="addNewBasketButton"
          (click)="addNewBasket(data.baskets); multiBasketIndex = 0"
          [disabled]="data.baskets?.length >= maxBasketNumber"
          [ngbTooltip]="data.baskets?.length >= maxBasketNumber ? tooltipContent : null"
          placement="left"
          triggers="manual"
          #tt6="ngbTooltip"
          (mouseenter)="tt6.open()"
          (focus)="tt6.open()"
          (blur)="tt6.close()"
        >
          @if (!displayItinerary) {
            <span i18n="@@basketPanelAddNewBasket">Add New Basket</span>
          }
          @if (displayItinerary) {
            <span i18n="@@basketPanelAddNewItinerary">Add New Itinerary</span>
          }
        </button>
      </section>
      <ng-template #tooltipContent>
        @if (!displayItinerary) {
          <p i18n="@@maximumnumberofbaskets">
            You currently have the maximum number of baskets allowed.
          </p>
        }
        @if (displayItinerary) {
          <p i18n="@@maximumnumberofitineraries">
            You currently have the maximum number of itineraries allowed.
          </p>
        }
      </ng-template>
    </div>
    @if (!data.deletingBasket) {
      <mat-tab-group
        class="basket_tabs"
        [(selectedIndex)]="multiBasketIndex"
        [disablePagination]="true"
        #basketTabGroup
      >
        <mat-tab
          label="Current {{ (displayItinerary ? 'Itinerary' : 'Basket') | translate }}"
          i18n-label
        >
          @if (!data.selectedBasket || !data.selectedBasket.id) {
            <div class="no_basket_warning recent_searches_no_recent">
              @if (!displayItinerary) {
                <i class="material-icons no_recent_icon" aria-hidden="true">shopping_basket</i>
                <h2 class="no_recent_header" i18n="@@YouHaveNoBasket">
                  You currently have no baskets
                </h2>
                <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketMessage">
                  Start adding items to your basket to see them here.
                </p>
              }
              @if (displayItinerary) {
                <img
                  class="luggage_icon no_recent_icon"
                  aria-hidden="true"
                  src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/luggage_icon.svg"
                  alt=""
                />
                <h2 class="no_recent_header" i18n="@@YouHaveNoBasketItin">
                  You currently have no itineraries
                </h2>
                <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketItinMessage">
                  Start adding items to your itinerary to see them here.
                </p>
              }
            </div>
          }
          @if (data.selectedBasket && data.selectedBasket.id) {
            <div>
              <div class="multi_basket_header multi_basket_header--selected">
                @if (!editNameMode) {
                  <span class="multi_basket_name">{{ data.selectedBasket.title }}</span>
                }
                @if (editNameMode) {
                  <div class="flex-column-container">
                    <label id="new_basket_title">
                      @if (displayItinerary) {
                        <span i18n="@@newItineraryTitle"> New Itinerary Title: </span>
                      }
                      @if (!displayItinerary) {
                        <span i18n="@@newBasketTitle"> New Basket Title: </span>
                      }
                    </label>
                    <input [(ngModel)]="renameString" aria-labelledby="new_basket_title" />
                  </div>
                }
                <div class="multi_basket_functions">
                  @if (data.selectedBasket.basketItems?.length) {
                    <section (mouseleave)="tt1.close()">
                      <button
                        class="multi_basket_button"
                        ngbTooltip="Share {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        attr.aria-label="Share {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        i18n-ngbTooltip
                        i18n-aria-label
                        placement="left"
                        (click)="openShareBasket(data.selectedBasket)"
                        triggers="manual"
                        #tt1="ngbTooltip"
                        (mouseenter)="tt1.open()"
                        (focus)="tt1.open()"
                        (blur)="tt1.close()"
                      >
                        @if (!displayItinerary) {
                          <svg
                            class="share-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 28"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <path
                                id="share-icon-path"
                                fill="#000"
                                fill-rule="nonzero"
                                d="M23.333 0a4.667 4.667 0 0 0-4.666 4.667c.002.328.038.655.109.975L8.18 10.94a4.667 4.667 0 0 0-3.513-1.607 4.667 4.667 0 0 0 0 9.334 4.667 4.667 0 0 0 3.516-1.605l10.588 5.296a4.667 4.667 0 1 0 4.562-3.691 4.667 4.667 0 0 0-3.516 1.604L9.23 14.975c.069-.32.104-.647.104-.975a4.667 4.667 0 0 0-.109-.973L19.82 7.729a4.667 4.667 0 0 0 3.513 1.604 4.667 4.667 0 1 0 0-9.333z"
                              />
                            </g>
                          </svg>
                        }
                        @if (displayItinerary) {
                          <img
                            src="https://images.sabscorp.com/images/enterprise/lightUK/assets/png/share_itinerary.png"
                            alt=""
                            class="share-icon"
                          />
                        }
                      </button>
                    </section>
                  }
                  @if (!editNameMode) {
                    <section (mouseleave)="tt2.close()">
                      <button
                        class="multi_basket_button"
                        ngbTooltip="Edit {{
                          (displayItinerary ? 'Itinerary' : 'Basket') | translate
                        }} Title"
                        attr.aria-label="Edit selected {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }} title"
                        i18n-ngbTooltip
                        i18n-aria-label
                        placement="left"
                        (click)="openBasketRename(data.selectedBasket)"
                        triggers="manual"
                        #tt2="ngbTooltip"
                        (mouseenter)="tt2.open()"
                        (focus)="tt2.open()"
                        (blur)="tt2.close()"
                      >
                        <i class="ico-edit" aria-hidden="true"></i>
                      </button>
                    </section>
                  }
                  @if (editNameMode) {
                    <section (mouseleave)="tt4.close()">
                      <button
                        class="multi_basket_button"
                        ngbTooltip="Save Title Change"
                        aria-label="Save selected {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }} title"
                        i18n-aria-label
                        i18n-ngbTooltip
                        placement="left"
                        (click)="saveBasketRename(data.selectedBasket)"
                        triggers="manual"
                        #tt4="ngbTooltip"
                        (mouseenter)="tt4.open()"
                        (focus)="tt4.open()"
                        (blur)="tt4.close()"
                      >
                        <i class="ico-check-1" aria-hidden="true"></i>
                      </button>
                    </section>
                  }
                  @if (editNameMode) {
                    <section (mouseleave)="tt5.close()">
                      <button
                        class="multi_basket_button"
                        ngbTooltip="Cancel Title Change"
                        aria-label="Cancel selected {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }} title change"
                        i18n-aria-label
                        i18n-ngbTooltip
                        placement="left"
                        (click)="cancelBasketRename()"
                        triggers="manual"
                        #tt5="ngbTooltip"
                        (mouseenter)="tt5.open()"
                        (focus)="tt5.open()"
                        (blur)="tt5.close()"
                      >
                        <i class="ico-cancel" aria-hidden="true"></i>
                      </button>
                    </section>
                  }
                  <section (mouseleave)="tt3.close()">
                    <button
                      class="multi_basket_button"
                      ngbTooltip="Delete {{
                        (displayItinerary ? 'itinerary' : 'basket') | translate
                      }}"
                      attr.aria-label="Delete selected {{
                        (displayItinerary ? 'itinerary' : 'basket') | translate
                      }}"
                      i18n-ngbTooltip
                      id="basket-button-delete-basket"
                      placement="left"
                      [disabled]="deletingBasket"
                      (click)="closeAndDeleteBasket(data.selectedBasket.id)"
                      triggers="manual"
                      #tt3="ngbTooltip"
                      (mouseenter)="tt3.open()"
                      (focus)="tt3.open()"
                      (blur)="tt3.close()"
                    >
                      <i class="ico-trash" aria-hidden="true"></i>
                    </button>
                  </section>
                </div>
              </div>
              <app-basket-invoked-user
                [basket]="data.baskets[getSelectedBasketIndex(data.baskets)]?.subject | async"
              >
              </app-basket-invoked-user>
              <div class="cart_panel_items">
                <!-- Cart items -->
                @if (
                  ((data.selectedBasket || { basketItems: [] }).basketItems || []).length == 0 &&
                  data &&
                  data.baskets &&
                  data.selectedBasket
                ) {
                  <div class="cart_item">
                    @if (!displayItinerary) {
                      <span i18n="@@basketPanelNoItems">There are no items in your basket.</span>
                    }
                    @if (displayItinerary) {
                      <span i18n="@@basketPanelNoItemsItinerary"
                        >There are no items in your itinerary.</span
                      >
                    }
                  </div>
                }
                @if (!(data && data.baskets && data.selectedBasket)) {
                  <div
                    class="cart_item"
                    role="status"
                    aria-live="polite"
                    aria-label="Loading basket"
                  >
                    <app-loading-spinner size="sm" />
                  </div>
                }
                @for (
                  basketItem of data.selectedBasket.basketItems;
                  track trackbyId(i, basketItem);
                  let i = $index
                ) {
                  <div class="cart_item">
                    @switch (basketItem.service.type) {
                      @case (ItemTypes.Flight) {
                        <app-basket-flight
                          [displayItinerary]="displayItinerary"
                          [flight]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-flight>
                      }
                      @case (ItemTypes.Lounge) {
                        <app-basket-lounge
                          [displayItinerary]="displayItinerary"
                          [lounge]="basketItem"
                          [itemIndex]="i"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-lounge>
                      }
                      @case (ItemTypes.Car) {
                        <app-basket-car-hire
                          [displayItinerary]="displayItinerary"
                          [car]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-car-hire>
                      }
                      @case (ItemTypes.Hotel) {
                        <app-basket-hotel
                          [displayItinerary]="displayItinerary"
                          [hotel]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-hotel>
                      }
                      @case (ItemTypes.Parking) {
                        <app-basket-parking
                          [displayItinerary]="displayItinerary"
                          [parking]="basketItem"
                          [itemIndex]="i"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-parking>
                      }
                      @case (ItemTypes.Rail) {
                        <app-basket-rail
                          [displayItinerary]="displayItinerary"
                          [rail]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-rail>
                      }
                      @case (ItemTypes.InternationalRail) {
                        <app-basket-irl
                          [displayItinerary]="displayItinerary"
                          [rail]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-irl>
                      }
                      @case (ItemTypes.Cab) {
                        <app-basket-taxi
                          [displayItinerary]="displayItinerary"
                          [taxi]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-taxi>
                      }
                      @case (ItemTypes.Eurostar) {
                        <app-basket-eurostar
                          [displayItinerary]="displayItinerary"
                          [eurostar]="basketItem"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-eurostar>
                      }
                      @case (ItemTypes.FastTrack) {
                        <app-basket-fast-track
                          [displayItinerary]="displayItinerary"
                          [fastTrack]="basketItem"
                          [itemIndex]="i"
                          (remove)="removeBasketItemCheck(basketItem)"
                          (openChangeModal)="openMoveBasketModal(basketItem, data)"
                        >
                        </app-basket-fast-track>
                      }
                    }
                  </div>
                }
                @if (data?.selectedBasket?.basketItems?.length > 0) {
                  <app-price-breakdown
                    [index]="getSelectedBasketIndex(data.baskets)"
                  ></app-price-breakdown>
                }
              </div>
            </div>
          }
        </mat-tab>
        @if (maxBasketNumber > 1) {
          <mat-tab
            label="Other {{ (displayItinerary ? 'Itineraries' : 'Baskets') | translate }}"
            i18n-label
          >
            @if (data.baskets.length === 1 || !data.baskets?.length) {
              <div class="no_basket_warning recent_searches_no_recent">
                @if (!displayItinerary) {
                  <i class="material-icons no_recent_icon" aria-hidden="true">shopping_basket</i>
                  <h2 class="no_recent_header" i18n="@@YouHaveNoBasketOther">
                    You currently have no other baskets
                  </h2>
                  @if (data.baskets?.length) {
                    <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketMessageOther">
                      Create another basket to see it here.
                    </p>
                  } @else {
                    <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketMessageOtherNo">
                      Create at least two baskets to see one here.
                    </p>
                  }
                }
                @if (displayItinerary) {
                  <img
                    class="luggage_icon recent_searches_no_recent"
                    aria-hidden="true"
                    src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/luggage_icon.svg"
                    alt=""
                  />
                  <h2 class="no_recent_header" i18n="@@YouHaveNoBasketItinOther">
                    You currently have no other itineraries
                  </h2>
                  @if (data.baskets?.length) {
                    <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketMessageOtherItin">
                      Create another itinerary to see it here.
                    </p>
                  } @else {
                    <p class="no_recent_tag_line" i18n="@@YouHaveNoBasketMessageOtherNoItintwo">
                      Create at least two itineraries to see one here.
                    </p>
                  }
                }
              </div>
            }

            @for (basket of data.baskets | filterUnique; track basket; let index = $index) {
              @if (basket.title && selectedBasketIndex !== basket.id) {
                <div class="multi_basket_div">
                  <div
                    class="multi_basket_header"
                    [ngClass]="{
                      'multi_basket_header--selected': selectedBasketIndex === basket.id
                    }"
                  >
                    <ng-container>
                      <span class="multi_basket_name">{{ basket.title }}</span>
                      <div class="multi_basket_functions">
                        <button
                          appButton="small"
                          attr.aria-label="Select Basket {{ basket.title }}"
                          (click)="changeBasketSelect(data, basket); multiBasketIndex = 0"
                        >
                          @if (displayItinerary) {
                            <span i18n="@@selectItinerary"> Select Itinerary </span>
                          }
                          @if (!displayItinerary) {
                            <span i18n="@@selectBasket"> Select Basket </span>
                          }
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              }
            }
          </mat-tab>
        }
      </mat-tab-group>
    }
    @if (data.deletingBasket) {
      <div role="status" aria-live="polite">
        <app-loading-spinner size="sm" />
        <div class="flex-row-container flex-row-container--center">
          @if (!displayItinerary) {
            <span class="loading-screen-text" i18n="@@basketPanelDeletingBasket"
              >Deleting Basket...</span
            >
          }
          @if (displayItinerary) {
            <span class="loading-screen-text" i18n="@@basketPanelDeletingItinerary"
              >Deleting Itinerary...</span
            >
          }
        </div>
      </div>
    }
  </div>
  @if (!data.deletingBasket && data?.selectedBasket?.basketItems?.length > 0) {
    <div class="cart_panel_buttons">
      <button
        (click)="continue(data.selectedBasket.basketItems, selectedBasketIndex)"
        [disabled]="data.miUpdating"
        appButton="large"
        class="large-button--max-width large-button--no-margin"
        id="basket-button-continue"
        attr.aria-label="Continue to basket ({{ data.selectedBasket.basketItems.length }} {{
          data.selectedBasket.basketItems.length > 1 ? 'Items' : 'Item'
        }} in basket)"
      >
        @if (data.miUpdating) {
          <span role="status" aria-live="polite" aria-label="Updating basket"
            ><i class="button_spinner input-loading-spinner-left smaller-size"></i
          ></span>
        }
        @if (!data.miUpdating) {
          <span i18n="@@basketPanelContinueButton">Continue</span>
        }
      </button>
    </div>
  }
}
